import * as types from './types';
import * as _ from 'lodash';

import { EditServedItemFieldEnum } from 'Common/FieldEnum';
import { formatDecimal, formatToCashExtraPrecision } from 'Common/FormHelper';

import { PriceFields } from '../../helpers/EditItemHelpers';

const INITIAL_STATE = {
  itemData: {},
  nutritionCodes: [],
  itemCategories: [],
  alternateItems: [],
  color: '',
  grades: [],
  loading: false,
  fetchError: '',
  fetching: false,
  newItemId: '',
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.EDIT_SERVED_ITEM_GET_DATA:
      var formattedData = _.cloneDeep(payload);
      if (formattedData && formattedData[EditServedItemFieldEnum.Prices]) {
        const fields = [
          PriceFields.FreePrice,
          PriceFields.StudentPrice,
          PriceFields.AdultPrice,
          PriceFields.CateredPrice,
          PriceFields.StaffPrice,
          PriceFields.TeacherPrice,
          PriceFields.ReducedPrice,
        ];

        formattedData[EditServedItemFieldEnum.Prices].forEach(price => {
          fields.forEach(field => {
            price[field] = formatDecimal(2)(price[field]);
          });

          formattedData[
            EditServedItemFieldEnum.ServingCost
          ] = formatToCashExtraPrecision(4)(
            formattedData[EditServedItemFieldEnum.ServingCost]
          );
        });
      }
      return {
        ...state,
        itemData: formattedData,
      };
    case types.EDIT_SERVED_ITEM_NEW_ID:
      return {
        ...state,
        newItemId: payload.Data,
      };
    case types.EDIT_SERVED_ITEM_GET_ITEM_CATEGORIES:
      return {
        ...state,
        itemCategories: payload,
      };
    case types.EDIT_SERVED_ITEM_GET_ALTERNATE_ITEMS:
      return {
        ...state,
        alternateItems: payload,
      };
    case types.EDIT_SERVED_ITEM_GET_NUTRITION_CODES:
      return {
        ...state,
        nutritionCodes: payload,
      };
    case types.EDIT_SERVED_ITEM_GET_GRADES:
      return { ...state, grades: payload };
    case types.EDIT_SERVED_ITEM_FETCH_ERROR:
      return { ...state, fetchError: payload };

    case types.EDIT_SERVED_ITEM_FETCHING:
      return { ...state, fetching: payload };

    case types.EDIT_SERVED_ITEM_CLEAR_STATE:
      return { ...INITIAL_STATE };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/state/editserveditem/reducer.js